"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigEpic = void 0;
var _reduxObservable = require("redux-observable");
var _types = require("./types");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _actions = require("./actions");
var _types2 = require("../loader/types");
var _types3 = require("../com/types");
var _types4 = require("../bet/types");
var _types5 = require("../blitz/types");
var _types6 = require("../realityCheck/types");
var _types7 = require("../practice/types");
var _CommandType = require("../../dovahzul/CommandType");
var _localStorageService = require("../../../utils/localStorageService");
var _cookieService = require("../../../utils/cookieService");
var _logger = _interopRequireDefault(require("../../../utils/logger"));
var _types8 = require("../balance/types");
var _Channel = require("../../common/enums/Channel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ConfigEpic = exports.ConfigEpic = /*#__PURE__*/_createClass(function ConfigEpic() {
  var _this = this;
  _classCallCheck(this, ConfigEpic);
  _defineProperty(this, "cookieService", void 0);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.setSettingsCookie, _this.loadCookies, _this.commandGameConfiguration, _this.responsibleGaming, _this.startInBlitzMode, _this.playForRealPopup, _this.hideCurrencySignBalanceBetUpdate);
  });
  _defineProperty(this, "responsibleGaming", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.SERVER_CONFIG), (0, _operators.filter)(function (a) {
      return a.payload.rcIntervalTime;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.of)({
        type: _types6.RC_ON,
        payload: {
          interval: store.value.config.rcIntervalTime,
          next: store.value.config.rcCurrentSessionTime ? store.value.config.rcIntervalTime - store.value.config.rcCurrentSessionTime % store.value.config.rcIntervalTime : store.value.config.rcIntervalTime
        }
      });
    }));
  });
  /** ensure balance and bet views update on toggle of currency sign config */
  _defineProperty(this, "hideCurrencySignBalanceBetUpdate", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.CURRENCY_SIGN_HIDE_TOGGLE), (0, _operators.mapTo)({
      type: _types8.UPDATE_BALANCE
    }));
  });
  _defineProperty(this, "startInBlitzMode", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.SERVER_CONFIG), (0, _operators.filter)(function (a) {
      return !!a.payload.blitz;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.HIDE_SPLASH_SCREEN
      }), (0, _rxjs.of)({
        type: _types5.BLITZ_MODE_ON
      }).pipe((0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types5.BLITZ_MODE_OFF))), (0, _operators.delay)(3000)));
    }));
  });
  /**
   * Note Config from server saying its practice likely comes after we get the action with the pfrUrl (from qs)
   */
  _defineProperty(this, "playForRealPopup", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.SERVER_CONFIG), (0, _operators.filter)(function (a) {
      return a.payload.practice && !!store.value.config.pfrUrl;
    }), (0, _operators.mapTo)({
      type: _types7.PFR_ON,
      payload: {
        interval: store.value.config.pfri
      }
    }));
  });
  _defineProperty(this, "loadCookies", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.START_LOADING), (0, _operators.mergeMap)(function () {
      var cookies = _this.cookieService.getAll(store.value.config.gameId + "_");
      // the hide splash screen function should not kick in on mobile,
      // this mostly only an issue when debuggin in mobile mode on desktop having set the cookie on this domain.
      // maybe all cookies should have channel prefix just like game id?
      if (cookies.splashScreenHide && store.value.config.channel != _Channel.Channel.Mobile) cookies.splashScreen = false;

      //    console.log('LOADED COOKIES')
      //    console.dir(cookies)

      return (0, _rxjs.of)((0, _actions.UpdateConfig)(cookies));
    }));
  });
  _defineProperty(this, "setSettingsCookie", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.SOUND_TOGGLE, _types.FAST_PLAY_TOGGLE, _types.VIBRATE_TOGGLE, _types.AUTO_ADJUST_BET_TOGGLE, _types.SPIN_ON_SPACE_TOGGLE, _types5.BLITZ_FEATURE_STOP_TOGGLE, _types5.SPLASH_SCREEN_HIDE_TOGGLE, _types5.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE, _types.HIDE_CURRENCY_SIGN_TOGGLE), (0, _operators.mergeMap)(function (a) {
      var pFix = store.value.config.gameId + "_";
      switch (a.type) {
        case _types.SOUND_TOGGLE:
          {
            _this.cookieService.set(pFix, "sound", store.value.config.sound.toString(), {
              expires: 365
            });
            break;
          }
        case _types.FAST_PLAY_TOGGLE:
          {
            _this.cookieService.set(pFix, "fastPlay", store.value.config.fastPlay.toString(), {
              expires: 365
            });
            break;
          }
        case _types.VIBRATE_TOGGLE:
          {
            _this.cookieService.set(pFix, "vibrate", store.value.config.vibrate.toString(), {
              expires: 365
            });
            break;
          }
        case _types.AUTO_ADJUST_BET_TOGGLE:
          {
            _this.cookieService.set(pFix, "autoAdjustBet", store.value.config.autoAdjustBet.toString(), {
              expires: 365
            });
            break;
          }
        case _types.SPIN_ON_SPACE_TOGGLE:
          {
            _this.cookieService.set(pFix, "spaceToSpin", store.value.config.spaceToSpin.toString(), {
              expires: 365
            });
            break;
          }
        case _types5.BLITZ_FEATURE_STOP_TOGGLE:
          {
            _this.cookieService.set(pFix, "blitzStopOnFeature", store.value.config.blitzStopOnFeature.toString(), {
              expires: 365
            });
            break;
          }
        case _types5.SPLASH_SCREEN_HIDE_TOGGLE:
          {
            _this.cookieService.set(pFix, "splashScreenHide", store.value.config.splashScreenHide.toString(), {
              expires: 365
            });
            break;
          }
        case _types5.BLITZ_SPLASH_SCREEN_HIDE_TOGGLE:
          {
            _this.cookieService.set(pFix, "blitzSplashScreenHide", store.value.config.blitzSplashScreenHide.toString(), {
              expires: 365
            });
            break;
          }
        case _types.HIDE_CURRENCY_SIGN_TOGGLE:
          {
            _this.cookieService.set(pFix, "hideCurrencySign", store.value.config.hideCurrencySign.toString(), {
              expires: 365
            });
            return (0, _rxjs.of)({
              type: _types8.UPDATE_BALANCE_FORCE
            });
          }
      }
      return _rxjs.EMPTY;
    }));
  });
  _defineProperty(this, "commandGameConfiguration", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.GameConfigurationResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      var command = a.payload;
      _logger["default"].dir("Game Config", command);
      return (0, _rxjs.of)({
        type: _types4.SET_DEFAULT_BET,
        payload: {
          denomination: command.defaultDenomination,
          denominations: command.denominations,
          featureBuyDenominations: command.featureBuyDenominations,
          blitzDenominations: command.blitzDenominations
        }
      }, {
        type: _types.SERVER_CONFIG,
        payload: {
          rtp: command.rtp,
          outcomeDebug: command.outcomeDebug,
          featureBuy: command.featureBuy,
          maxWin: command.maxWin
        }
      });
    }));
  });
  var mod = "LSTEST";
  try {
    localStorage.setItem(mod, mod);
    localStorage.removeItem(mod);
    this.cookieService = new _localStorageService.LocalStorageService();
  } catch (e) {
    console.warn("cookieFallBack");
    this.cookieService = new _cookieService.CookieService();
  }
});
//# sourceMappingURL=epics.js.map